import React from 'react';
import { Tooltip } from '../Tooltip';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var DEFAULT_ERROR_MESSAGE = 'Something went wrong';
export function ButtonError(_ref) {
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? DEFAULT_ERROR_MESSAGE : _ref$errorMessage,
    isVisible = _ref.isVisible,
    children = _ref.children;
  return _jsx(Tooltip, {
    isDisabled: !isVisible,
    isOpen: true,
    trigger: children,
    view: "error",
    position: "bottom",
    children: errorMessage
  });
}
//# sourceMappingURL=index.js.map